import { render, staticRenderFns } from "./StContainerTabsAccordion.vue?vue&type=template&id=a808468c"
import script from "./StContainerTabsAccordion.vue?vue&type=script&lang=ts"
export * from "./StContainerTabsAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports